import Tool from './Tool';
import Shortcut from '../utils/Shortcut';

const moveSelection = (controller, selection, deltaX, deltaY) => {
  const zoom = controller.canvas.getZoom();

  deltaX = deltaX / zoom;
  deltaY = deltaY / zoom;
  selection.moveToCoords({
    left: selection.left + deltaX,
    top: selection.top + deltaY,
  });
  controller.canvas.temporaryHideObjectToolbar();
  controller.canvas.requestRenderAll();
};

class ToolMove extends Tool {
  static allowsRepeat = true;
}

class ToolMoveUp extends ToolMove {
  static toolName = 'Move up';
  static shortcut = new Shortcut('Up');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 0, -1);
  }
}

class ToolMoveDown extends ToolMove {
  static toolName = 'Move down';
  static shortcut = new Shortcut('Down');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 0, 1);
  }
}

class ToolMoveLeft extends ToolMove {
  static toolName = 'Move left';
  static shortcut = new Shortcut('Left');

  static action({ controller, selection }) {
    moveSelection(controller, selection, -1, 0);
  }
}

class ToolMoveRight extends ToolMove {
  static toolName = 'Move right';
  static shortcut = new Shortcut('Right');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 1, 0);
  }
}

class ToolBigMoveUp extends ToolMove {
  static toolName = 'Big move up';
  static shortcut = new Shortcut('Shift+Up');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 0, -10);
  }
}

class ToolBigMoveDown extends ToolMove {
  static toolName = 'Big move down';
  static shortcut = new Shortcut('Shift+Down');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 0, 10);
  }
}

class ToolBigMoveLeft extends ToolMove {
  static toolName = 'Big move left';
  static shortcut = new Shortcut('Shift+Left');

  static action({ controller, selection }) {
    moveSelection(controller, selection, -10, 0);
  }
}

class ToolBigMoveRight extends ToolMove {
  static toolName = 'Big move right';
  static shortcut = new Shortcut('Shift+Right');

  static action({ controller, selection }) {
    moveSelection(controller, selection, 10, 0);
  }
}

export {
  ToolMoveUp,
  ToolMoveDown,
  ToolMoveLeft,
  ToolMoveRight,
  ToolBigMoveUp,
  ToolBigMoveDown,
  ToolBigMoveLeft,
  ToolBigMoveRight,
};
